import { render, staticRenderFns } from "./simplelogin.vue?vue&type=template&id=765d248a"
import script from "./simplelogin.vue?vue&type=script&lang=js"
export * from "./simplelogin.vue?vue&type=script&lang=js"
import style0 from "./simplelogin.vue?vue&type=style&index=0&id=765d248a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports